import { ElementRef, Injectable, inject } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';
import { Observable, Subject } from 'rxjs';

export interface TooltipData {
    content: ElementRef[];
    reference: ElementRef;
    cssClass: string;
    tooltipPlacement: string;
    hideOnScroll: boolean;
    showOnLoad: boolean;
    appendContent: boolean;
}
export interface TooltipRequest {
    data?: TooltipData;
    visible: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class TooltipService {
    private device = inject(DeviceService);

    private _tooltipRequested: Subject<TooltipRequest> = new Subject<TooltipRequest>();

    get visibility(): Observable<TooltipRequest> {
        return this._tooltipRequested.asObservable();
    }

    show(options: TooltipData): void {
        if (this.device.isTouch && !options.showOnLoad) {
            return;
        }

        this._tooltipRequested.next({ visible: true, data: options });
    }

    hide(showOnLoad: boolean): void {
        if (this.device.isTouch && !showOnLoad) {
            return;
        }

        this._tooltipRequested.next({ visible: false });
    }
}
